//
//
//
//

import TextColorable from "../../mixins/TextColorable";
import TextSizeable from "../../mixins/TextSizeable";

export default {
    name: "MetaText",

    mixins: [TextSizeable, TextColorable]
}
